module.exports = __webpack_public_path__ + "static/media/write.f02ed005.jpg";